import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_7: DocMigration = {
  maxSchemaVersion: "0.0.7",
  apply(json: any) {
    if (!json.electricalSystem) {
      json.electricalSystem = defaultEmptyElectricalSystem;
    }

    return json;
  },
};

const defaultEmptyElectricalSystem = {
  loads: {},
  controllers: {},
  embeddedGroups: {},
  independentLoadArrays: {},
  roomClearRules: {},
  roomEmbeddedGroups: {},
  roomIndependentLoadArrays: {},
};

export default migration_0_0_7;
